import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { Button, Panel, PanelGroup, Section } from '@lanl-web/lanl-components';

import LAROIcon from '../../assets/svg/LARO.inline.svg';
import EPRRIcon from '../../assets/svg/EPRR.inline.svg';
import SubjectGuidesIcon from '../../assets/svg/subject-guides.inline.svg';

import './StrategicPlan.scss';

export const StrategicPlan = ({ className, showButton }) => {
  const classes = classNames('strategic-plan-section', className);

  return (
    <Section backgroundColor='white' className={classes}>
      <PanelGroup divider className='value-panel'>
        <Panel
          link=''
          icon={<LAROIcon />}
          title='Mission'
          description='We amplify the Laboratory’s mission-driven research by enabling LANL researchers to learn powerful skills and access expertise and scholarly information, developing new methods for managing data and information, and connecting researchers with colleagues and the broader scientific ecosystem.'
        />
        <Panel
          link=''
          icon={<EPRRIcon />}
          title='Vision'
          description='We are shaping the future of research libraries: digital-first institutions with a seamless user experience and services that evolve with the open and classified information ecosystem, and where collaboration and open scientific research are integral.'
        />
      </PanelGroup>

      {showButton && (
        <div className='btn-box'>
          <Button arrow={false}>Strategic Plan</Button>
        </div>
      )}
    </Section>
  );
};

StrategicPlan.defaultProps = {
  showButton: false,
};

StrategicPlan.propTypes = {
  className: PropTypes.string,
  showButton: PropTypes.bool,
};

export default StrategicPlan;
